import React from "react";
import "./Terms_Conditions.css";
import { Navigate, useNavigate } from "react-router-dom";

const TermsConditions = () => {
  const navigate = useNavigate();
const handleScroll = (id) => {
  const container = document.querySelector(".terms-content");
  const section = document.getElementById(id);

  if (container && section) {
    const containerTop = container.getBoundingClientRect().top;
    const sectionTop = section.getBoundingClientRect().top;

    const offset = 20; // 30px margin from top

    container.scrollTo({
      top: container.scrollTop + (sectionTop - containerTop) - offset,
      behavior: "smooth",
    });
  }
};

  return (
    <>
      <section className="term_conditions">
        <div className="terms-header container">
          <h1>TERMS AND CONDITIONS</h1>
          <p>
            Last updated January 14, 2026. These terms outline the rules and
            regulations for the use of the 11 Dreams platform.
          </p>
        </div>

        <section className="terms-wrapper">
          <aside className="terms-sidebar">
            <div className="jump-box">
              <h3>Jump to Sections</h3>
              <p>Quick Navigation</p>
              <ul>
                <li onClick={() => handleScroll("introduction")}>
                  1. Introduction
                </li>
                <li onClick={() => handleScroll("eligibility")}>
                  2. Eligibility
                </li>
                <li onClick={() => handleScroll("account-security")}>
                  3. Account Security
                </li>
                <li onClick={() => handleScroll("betting-rules")}>
                  4. Betting Rules
                </li>
                <li onClick={() => handleScroll("payments")}>
                  5. Payments & Withdrawals
                </li>
                <li onClick={() => handleScroll("disclaimer")}>
                  6. Disclaimers
                </li>
              </ul>
            </div>

            <div className="need-help-box">
              <h4>Need help?</h4>
              <p>Our support team is available 24/7 for legal inquiries.</p>
                 <button onClick={() => navigate("/contactus")}>Contact Us</button>
            </div>
          </aside>

          <div className="terms-content">
            <div id="introduction" className="terms-section">
              <h2>
                <span>1.</span> Introduction
              </h2>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book. It has
                survived not only five centuries, but also the leap into
              </p>

              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book. It has
                survived not only five centuries, but also the leap into
                electronic typesetting, remaining essentially unchanged.
              </p>
            </div>

            <div id="eligibility" className="terms-section">
              <h2>
                <span>2.</span> Eligibility
              </h2>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book. It has
                survived not only five centuries, but also the leap into
              </p>

              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book. It has
                survived not only five centuries, but also the leap into
                electronic typesetting, remaining essentially unchanged.
              </p>
            </div>

            <div id="account-security" className="terms-section">
              <h2>
                <span>3.</span> Account Security
              </h2>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book. It has
                survived not only five centuries, but also the leap into
              </p>

              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book. It has
                survived not only five centuries, but also the leap into
                electronic typesetting, remaining essentially unchanged.
              </p>
            </div>

            <div id="betting-rules" className="terms-section">
              <h2>
                <span>4.</span> Betting Rules
              </h2>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book. It has
                survived not only five centuries, but also the leap into
              </p>

              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book. It has
                survived not only five centuries, but also the leap into
                electronic typesetting, remaining essentially unchanged.
              </p>
            </div>

            <div id="payments" className="terms-section">
              <h2>
                <span>5.</span> Payments & Withdrawals
              </h2>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book. It has
                survived not only five centuries, but also the leap into
              </p>

              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book. It has
                survived not only five centuries, but also the leap into
                electronic typesetting, remaining essentially unchanged.
              </p>
            </div>

            <div id="disclaimer" className="terms-section">
              <h2>
                <span>6.</span> Disclaimers
              </h2>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book. It has
                survived not only five centuries, but also the leap into
              </p>

              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book. It has
                survived not only five centuries, but also the leap into
                electronic typesetting, remaining essentially unchanged.
              </p>
            </div>
          </div>

          <div className="need-help-box-mobile">
            <h4>Need help?</h4>
            <p>Our support team is available 24/7 for legal inquiries.</p>
            <button onClick={() => navigate("/contactus")}>Contact Us</button>
          </div>
        </section>
      </section>
    </>
  );
};

export default TermsConditions;
